export { default as Points } from './Points';
export { default as Items } from './Items';
export { default as Timetable } from './Timetable';
export { default as SimpleTimetable } from './SimpleTimetable';
export { default as RoundRobinTable } from './RoundRobinTable';
export { default as FolkraceTable } from './FolkraceTable';



// WEBPACK FOOTER //
// ./src/private/common/components/Tournament/Tables/index.js